import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaArrowRight, FaCheck, FaShieldAlt, FaStethoscope, FaGraduationCap, FaBriefcase, FaHotel, FaUmbrellaBeach } from "react-icons/fa";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Slideshow from "../components/Slideshow";
import TrustBand from "../components/TrustBand";
import api from "../axios/api";

const Home = () => {
  
  const [parceiros, setParceiros] = useState([]);
  const [slides, setSlides] = useState([]);

  useEffect(() => {
    let isMounted = true;

    const fetchPartners = async () => {
      try {
        const res = await api.get("/parceiros");
        const dadosParceiros = Array.isArray(res.data) ? res.data : (res.data.data || []);
        if (isMounted) {
          setParceiros(dadosParceiros);
        }
      } catch (error) {
        console.error("Erro ao buscar parceiros:", error);
      }
    };

    const fetchSlides = async () => {
      try {
        const res = await api.get("/slideshows");
        const dadosSlides = Array.isArray(res.data) ? res.data : (res.data.data || []);
        if (isMounted) {
          setSlides(dadosSlides);
        }
      } catch (error) {
        console.error("Erro ao buscar slides:", error);
      }
    };

    fetchPartners();
    fetchSlides();

    return () => {
      isMounted = false;
    };
  }, []);

  const shouldLoop = parceiros.length >= 4;
  const renderParceiros = shouldLoop ? [...parceiros, ...parceiros] : parceiros;

  return (
    <main>
      <Header />
      <section className="home-hero p-0">
        <Slideshow slides={slides} />
      </section>

      <TrustBand />

      {/* Seção de Parceiros com Fundo Preto e Fluid (Sem Margens) */}
      <div className="container-fluid bg-black py-5 m-0 px-0">
        <div className="container-fluid px-0">
          <h2 className="section-title text-center text-white mb-5">Empresas que Confiam na Nossa Marca</h2>
          
          {shouldLoop ? (
            <div className="partners-carousel-container overflow-hidden position-relative py-3 w-100" style={{ whiteSpace: 'nowrap' }}>
              <div className="partners-track d-flex align-items-center gap-4" style={{ display: 'inline-flex', animation: 'scroll 25s linear infinite' }}>
                {renderParceiros.map((parceiro, index) => (
                  <div 
                    key={`${parceiro.id || index}-${index}`} 
                    className="partner-item bg-dark px-3 py-3 rounded-2 d-flex flex-column justify-content-center align-items-center border border-secondary text-center"
                    style={{ minWidth: '220px', height: '90px', whiteSpace: 'normal' }}
                  >
                    <span className="text-white fw-bold w-100" style={{ fontSize: '0.85rem', lineHeight: '1.2' }}>{parceiro.nome}</span>
                    <span className="text-muted w-100 mt-1" style={{ fontSize: '0.7rem' }}>{parceiro.categoria || parceiro.descricao || "Parceiro"}</span>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div className="d-flex justify-content-center align-items-center gap-4 flex-wrap py-3 px-3">
              {parceiros.map((parceiro, index) => (
                <div 
                  key={parceiro.id || index} 
                  className="partner-item bg-dark px-3 py-3 rounded-2 d-flex flex-column justify-content-center align-items-center border border-secondary shadow-sm text-center"
                  style={{ minWidth: '220px', height: '90px', whiteSpace: 'normal' }}
                >
                  <span className="text-white fw-bold w-100" style={{ fontSize: '0.85rem', lineHeight: '1.2' }}>{parceiro.nome}</span>
                  <span className="text-muted w-100 mt-1" style={{ fontSize: '0.7rem' }}>{parceiro.categoria || parceiro.descricao || "Parceiro"}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

       {/* Seção Inspirada no Layout de Destaque */}
      <section className="py-5 bg-white text-dark">
        <div className="container py-4">
          <div className="row align-items-center g-5">
            <div className="col-lg-6">
              <span className="text-warning fw-bold text-uppercase tracking-wider small mb-2 d-block">Excelência e Qualidade</span>
              <h2 className="display-5 fw-bold mb-4" style={{ lineHeight: '1.2' }}>
                Inovação e Tecnologia <span className="text-warning">para o seu negócio</span>
              </h2>
              <p className="text-secondary mb-4 lead" style={{ fontSize: '1rem' }}>
                Soluções completas e integradas: desenvolvimento tecnológico, capacitação profissional de alto nível, suporte especializado e inovação constante para impulsionar a sua empresa no mercado.
              </p>
              <div className="row g-3 mb-4">
                <div className="col-sm-6">
                  <div className="d-flex align-items-center gap-2">
                    <div className="badge bg-warning text-dark p-2 rounded-circle"><FaCheck /></div>
                    <span className="fw-semibold small">Capacitação prática</span>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="d-flex align-items-center gap-2">
                    <div className="badge bg-warning text-dark p-2 rounded-circle"><FaCheck /></div>
                    <span className="fw-semibold small">Tecnologia avançada</span>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="d-flex align-items-center gap-2">
                    <div className="badge bg-warning text-dark p-2 rounded-circle"><FaCheck /></div>
                    <span className="fw-semibold small">Suporte contínuo</span>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="d-flex align-items-center gap-2">
                    <div className="badge bg-warning text-dark p-2 rounded-circle"><FaCheck /></div>
                    <span className="fw-semibold small">Atendimento dedicado</span>
                  </div>
                </div>
              </div>
              <div className="d-flex flex-wrap gap-3">
                <Link to="/servicos" className="btn btn-warning fw-bold px-4 py-3 d-inline-flex align-items-center gap-2 text-dark">
                  Ver nossos serviços <FaArrowRight />
                </Link>
                <Link to="/contato" className="btn btn-outline-dark fw-bold px-4 py-3">
                  Fale Connosco
                </Link>
              </div>
            </div>
            
            <div className="col-lg-6">
              <div className="position-relative shadow-lg rounded-4 overflow-hidden border border-light">
                <div className="bg-dark text-white p-4 d-flex flex-column justify-content-center" style={{ minHeight: '380px', background: 'linear-gradient(135deg, #111 0%, #333 100%)' }}>
                  <span className="badge bg-warning text-dark align-self-start mb-3 px-3 py-2 fw-bold">Infraestrutura Moderna</span>
                  <h3 className="h3 fw-bold mb-3">Tecnologia & Formação de Ponta</h3>
                  <p className="text-light opacity-75 mb-0">Compromisso com o desenvolvimento técnico e profissional, garantindo eficiência, modernidade e resultados reais para os nossos clientes.</p>
                </div>
              </div>
            </div>
          </div>

          {/* Categorias / Áreas de Atuação */}
          <div className="row mt-5 pt-4 g-4">
            {[
              { title: "Segurança", desc: "Sistemas e proteção avançada para ambientes corporativos.", icon: <FaShieldAlt size={24} className="text-warning" /> },
              { title: "Tecnologia", desc: "Soluções de software, infraestrutura e suporte de TI.", icon: <FaBriefcase size={24} className="text-warning" /> },
              { title: "Educação", desc: "Cursos profissionais, certificações e capacitação técnica.", icon: <FaGraduationCap size={24} className="text-warning" /> },
              { title: "Consultoria", desc: "Estratégias especializadas para otimização de processos.", icon: <FaStethoscope size={24} className="text-warning" /> }
            ].map((item, idx) => (
              <div key={idx} className="col-md-6 col-lg-3">
                <div className="card h-100 border-0 shadow-sm p-4 bg-light rounded-3 text-start hover-shadow transition">
                  <div className="mb-3">{item.icon}</div>
                  <h5 className="fw-bold mb-2">{item.title}</h5>
                  <p className="text-muted small mb-3">{item.desc}</p>
                  <Link to="/servicos" className="text-dark fw-bold small text-decoration-none d-inline-flex align-items-center gap-1 mt-auto">
                    Saiba mais <FaArrowRight size={10} />
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>


      <style>{`
        @keyframes scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .partners-carousel-container:hover .partners-track {
          animation-play-state: paused;
        }
      `}</style>

      

      <Footer />
    </main>
  );
};

export default Home;